import styled from '../../../styles/theme';
import { ModalStyled } from '../ModalStyled';

export const ModalStyledDS = styled(ModalStyled)`
    .modalWindow__wrap {
        &__header__title {
            color: ${({ theme }) => theme.colors.grey6};
        }

        .modalFinancialSummary {
            color: ${({ theme }) => theme.colors.grey6};
            .finance-summary--grid .finance-summary--row-1 {
                padding: 0.5rem !important;
            }
        }
        &.finance-legal {
            .button-container {
                button:hover {
                    background: ${({ theme }) => theme.colors.primaryHover};
                }
            }
        }
    }

    p.MsoNormal span {
        font-family: ${({ theme }) => theme.fonts.fontBase} !important;
    }

    p span {
        font-family: ${({ theme }) => theme.fonts.fontBase} !important;
    }
`;
